(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7455],{

/***/ 66643:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-cases/portals",
      function () {
        return __webpack_require__(77699);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Portals; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_SectionHero__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38790);
/* harmony import */ var _components_templates_Solution__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2865);



var __N_SSG = true;
function Portals(param) {
    var solution = param.solution, preview = param.preview;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_Solution__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        page: solution,
        preview: preview,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SectionHero__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            title: "Empower customers and employees",
            description: "Give customers the information they seek, and employees the information they need, all with using fewer resources to maintain a better service. It’s a win-win."
        })
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3781,4814,3353,8009,6831,5343,1635,2456,9338,8953,2865,9774,2888,179], function() { return __webpack_exec__(66643); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);